import { Form, FormInstance, Select } from "antd";
import React, { useState } from "react";
import { useBillingPlans } from "../../../../../hooks/useBillingPlans";
import { DropDown } from "../../../../../assets/icons";
import { Modal as CustomModal } from "../../../../../components";
import { bold } from "../../../../../utils";
import { usePromotionPageStore } from "../../usePromotionPageStore";

interface Props {
  form: FormInstance;
}

export default function PromotionDetailsFormForRecurlySourceAppliedBillingPlanIds({ form }: Props) {
  const { billingPlans } = useBillingPlans();
  const [value, _setValue] = useState<string[]>(form.getFieldValue("appliedBillingPlanIds") || []);
  const setValue = (val: string[]) => {
    _setValue(val);
    form.setFieldsValue({ appliedBillingPlanIds: val });
  };
  const descriptionDisclosures = usePromotionPageStore((state) => state.descriptionDisclosures);

  const handleChange = (newValue: string[]) => {
    const prevValue = value;

    const isDeletion = newValue.length < prevValue.length;
    const deletedItems = prevValue.filter((item) => !newValue.includes(item));

    if (
      isDeletion &&
      deletedItems[0] &&
      deletedItems.length === 1 &&
      descriptionDisclosures.some((it) => it.billingPlanId === deletedItems[0])
    ) {
      CustomModal.confirm({
        title: `Delete ${deletedItems[0]}`,
        content: bold`Deselecting this plan will also delete its Description & Disclosure configuration. Are you sure you want to continue?`,
        onOk: () => {
          setValue(newValue);
          usePromotionPageStore.setState({
            descriptionDisclosures: descriptionDisclosures.filter((it) => it.billingPlanId !== deletedItems[0]),
          });
        },
        onCancel: () => {
          setValue(prevValue);
        },
      });
    } else {
      setValue(newValue);
    }
  };

  return (
    <Form.Item label="Applied billing plan" name="appliedBillingPlanIds">
      <Select
        allowClear
        optionFilterProp="label"
        getPopupContainer={(trigger) => trigger.parentNode}
        showArrow
        suffixIcon={<DropDown />}
        mode="multiple"
        placeholder="Please select applied billing plan"
        value={value}
        options={billingPlans.map(({ id, name }) => ({
          label: name,
          value: id,
        }))}
        onChange={handleChange}
      />
    </Form.Item>
  );
}
